import { TEXTOS } from '../lib/glossario'

/**
 * O que fica no lugar de um formulário que a conta não pode enviar.
 *
 * **Some a ação, fica a informação.** Um LEITOR que abre o fechamento precisa continuar vendo que o
 * valor da nota ainda não foi registrado e que a medição de infraestrutura falta — é metade da
 * razão de ele abrir a tela. O que ele não precisa é do formulário de nove campos cujo envio o
 * servidor recusa com 403.
 *
 * A alternativa — esconder a seção inteira — mentiria por omissão: a tela diria "não há nada a
 * registrar" quando o que há é "você não é quem registra".
 *
 * @param props o título da seção e a explicação que ela já daria a quem escreve
 * @returns a seção em modo consulta
 */
export function SomenteConsulta({ titulo, ajuda }: { titulo: string; ajuda?: string }) {
  return (
    <section className="cartao space-y-2 p-4" aria-label={titulo}>
      <h2 className="text-base font-semibold text-slate-900">{titulo}</h2>
      {ajuda && <p className="max-w-prose text-sm text-slate-600">{ajuda}</p>}
      <p className="max-w-prose text-sm text-slate-500">{TEXTOS.somenteConsulta}</p>
    </section>
  )
}
